import { getFullUrl } from 'hubspot-url-utils';
// @ts-ignore module not typed
import UrlPattern from 'PatternValidationJS/patterns/Url';
import PortalIdParser from 'PortalIdParser';

import { FullUserInformation } from '../../__generated__/chirp/com/hubspot/appusers/rpc/UsersRpc';

export const userSettingsUrl = (userId: FullUserInformation['id']) =>
  `${getFullUrl(
    'app'
  )}/settings/${PortalIdParser.get()}/users/user/${userId}?tab=accessTab`;

export const ssoSettingsUrl = () =>
  `${getFullUrl(
    'app'
  )}/settings/${PortalIdParser.get()}/security/login-settings`;

// UrlPattern.test with requireProtocol accepts both http:// and https:// and
// can't be told to reject http://, so https:// is checked manually.
export function isValidHttpsUrl(value: string) {
  return (
    value.toLowerCase().startsWith('https://') &&
    UrlPattern.test(value, { requireProtocol: true })
  );
}
